import { useCallback, useState } from 'react';

// Open/close + position state for the album/artist/playlist detail hero's
// "..." overflow menu. Deliberately a separate small hook rather than
// genericizing useTrackMenu (which is track-specific and already working) -
// same clamp-to-viewport approach, just without a payload item attached.
const MENU_WIDTH = 240;
const MENU_MARGIN = 8;

function clamp(x: number, y: number) {
    const maxX = window.innerWidth - MENU_WIDTH - MENU_MARGIN;
    const maxY = window.innerHeight - MENU_MARGIN;
    return { x: Math.max(MENU_MARGIN, Math.min(x, maxX)), y: Math.max(MENU_MARGIN, Math.min(y, maxY)) };
}

export interface DetailMenuPosition {
    x: number;
    y: number;
}

export function useDetailMenu() {
    const [position, setPosition] = useState<DetailMenuPosition | null>(null);

    const openAtElement = useCallback((e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        setPosition(clamp(rect.right - MENU_WIDTH, rect.bottom + 4));
    }, []);

    const close = useCallback(() => setPosition(null), []);

    return { position, openAtElement, close };
}
